Ext.define('SA.EditModelLocationsObserver', {
    statics: {
        observe(params) {
            new SA.EditModelLocationsObserver(params);
        }
    },

    constructor({observable, model, callback}) {
        var queueCoalescedCallback = SA.CoalescingMicroTask.coalesce(callback);

        this.model = model;
        this.callback = callback;

        observable.mon(model, 'change:location', queueCoalescedCallback);
        observable.mon(model.getProject(), 'change:location', queueCoalescedCallback);
        observable.mon(SA.data.LocationAliases, 'change', this.onAliasChange, this);
    },

    onAliasChange(location) {
        if (!this.model.projectHasLocation(location)) {
            return;
        }

        this.callback();
    }
});